import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WucLinkModule, WucListModule, WucSafeHtmlModule } from '@inshared/website-ui-components';
import { KnowledgebaseArticleListComponent } from './knowledgebase-article-list.component';

@NgModule({
    imports: [
        CommonModule,
        WucListModule,
        WucLinkModule,
        WucSafeHtmlModule,
    ],
    declarations: [
        KnowledgebaseArticleListComponent,
    ],
    exports: [
        KnowledgebaseArticleListComponent,
    ],
})
export class KnowledgeArticleListModule {
}
